import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';

import actions from '../../../../redux/actions';
import { RootState } from '../../../../redux/store';
import { CycleStatus } from '../../../../types/CycleStatus';
import { TesterStatusInCycle } from '../../../../types/TesterStatusInCycle';
import TesterBugsList from '../../../../_components/accounts/tester/bugs/TesterBugsList';
import { Notice, PageContainer, PageSection } from '../../../../ui';

/* Tester → cycle → Reported bugs. The cycle header and tabs come from TesterCycleNav. */
const Bugs: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const cycleId = +id;
  const history = useHistory();
  const dispatch = useDispatch();
  const { cycles, cycleBugs, resolution } = useSelector((state: RootState) => state);

  const cycle: any = (cycles as any[]).find((el) => el.id === cycleId);

  if (!cycle) {
    return null;
  }

  const bugs = cycleBugs.byCycleId[cycleId] || [];
  const bugEditingEnabled = [TesterStatusInCycle.Approved, TesterStatusInCycle.AwaitingReview].includes(cycle.testerStatus);
  const isMobile = resolution.device === 'mobile' || resolution.device === 'mobile-tablet';

  return (
    <PageContainer isMobile={isMobile}>
      {cycle.status === CycleStatus.Completed && (
        <Notice title="This cycle has finished">
          <Link to="/account/tester">Go to dashboard</Link>
        </Notice>
      )}
      <PageSection title={`Reported bugs (${bugs.length})`} padding={isMobile ? 1.5 : 2.5}>
        {bugs.length ? (
          <TesterBugsList
            bugs={bugs}
            cycle={cycle}
            isMobile={isMobile}
            onEdit={bugEditingEnabled ? (bugId) => history.push(`/account/tester/cycle/${cycleId}/bugs/${bugId}/edit`) : undefined}
            onDelete={bugEditingEnabled ? (bugId) => dispatch(actions.deleteBug(cycleId, bugId)) : undefined}
          />
        ) : (
          <Typography variant="body2" color="textSecondary">
            You have not found any bugs yet
          </Typography>
        )}
      </PageSection>
    </PageContainer>
  );
};

export default Bugs;
